export const resetFilterSearchParams = (searchParams, setSearchParams) => {
  searchParams.delete("country");
  searchParams.delete("runningOuts");
  searchParams.delete("dateStart");
  searchParams.delete("dateEnd");
  setSearchParams(searchParams);
};
